<div>
  <h1 class="text-2xl font-bold mb-4">Detalhes do evento</h1>

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  @if (loading) {
    <div class="mb-4">
      <app-loading size="large" color="primary"/>
    </div>
  }

  @if (!loading && auditEvent) {
    <div class="mb-6 space-y-1">
      <div><span class="font-semibold">ID:</span> {{ auditEvent.id }}</div>
      <div><span class="font-semibold">Trace ID:</span> {{ auditEvent.traceId }}</div>
      @if (auditEvent.referenceId) {
        <div><span class="font-semibold">Reference ID:</span> {{ auditEvent.referenceId }}</div>
      }
      <div><span class="font-semibold">Endereço de IP:</span> {{ auditEvent.ipAddress }}</div>
      <div><span class="font-semibold">User ID:</span> {{ auditEvent.userId }}</div>
      <div><span class="font-semibold">Nome de usuário:</span> {{ auditEvent.userName }}</div>
      <div><span class="font-semibold">Ação:</span> {{ auditFriendlyName(auditEvent.actionName) }}</div>
      <div><span class="font-semibold">Início:</span> {{ auditEvent.startTime | date: 'yyyy-MM-dd HH:mm:ss' }}</div>
      <div><span class="font-semibold">Tempo de execução:</span> {{ formatElapsed(auditEvent.elapsedSeconds) }}</div>
      <div><span class="font-semibold">Sucesso:</span> {{ auditEvent.success }}</div>
    </div>

    <div class="overflow-x-auto mt-2">
      <h2 class="text-lg font-bold mb-2">Mensagens</h2>
      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead>
          <tr class="bg-neutral-100 dark:bg-neutral-700">
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">ID</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Mensagem</th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2">Data</th>
          </tr>
        </thead>
        <tbody>
          @for (m of auditEvent.messages; track m.id; let even = $even) {
            <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ m.id }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ m.message }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ m.date | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
            </tr>
          } @empty {
            <tr class="bg-neutral-50 dark:bg-neutral-800">
              <td colspan="3">
                {{ 'AUDIT.MESSAGE.NO_ITEMS' | translate }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="overflow-x-auto mt-2">
      <h2 class="text-lg font-bold mb-2">Entidades</h2>
      <p class="text-neutral-500 dark:text-neutral-100 mb-2">
        As entidades são as informações que foram alteradas no banco de dados durante o evento.
      </p>
      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead>
        <tr class="bg-neutral-100 dark:bg-neutral-700">
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">ID</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">Ação</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">Entidade</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">Data</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2"></th>
        </tr>
        </thead>
        <tbody>
          @for (e of auditEvent.entities; track e.id; let even = $even) {
            <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ e.id }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ auditEntityActionName(e.action) }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ e.entityName }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ e.eventTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                <app-button color="primary" size="small" (click)="onOpenModal(e)" icon="eye"></app-button>
              </td>
            </tr>
          } @empty {
            <tr class="bg-neutral-50 dark:bg-neutral-800">
              <td colspan="8">
                {{ 'AUDIT.ENTITY.NO_ITEMS' | translate }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

<app-modal #entityModal [title]="modalTitle">
  <div class="max-h-[70vh] overflow-auto">
    @if (modalLoading) {
      <app-loading size="large" color="primary"/>
    } @else if (modalError) {
      <app-alert [type]="'danger'">{{ modalError }}</app-alert>
    } @else if (modalData) {
      @if (modalData.keys) {
        <p>Chaves:</p>
        <pre class="text-xs whitespace-pre-wrap">{{ modalData.keys }}</pre>
      }
      @if (originalModel && modifiedModel) {
        <p>Alterações:</p>
        <div style="min-height: 600px;">
          <ngx-monaco-diff-editor
            [originalModel]="originalModel"
            [modifiedModel]="modifiedModel"
            [options]="diffOptions"
          ></ngx-monaco-diff-editor>
        </div>
      } @else {
        @if (modalData.entityBefore) {
          <p>Entidade antes:</p>
          <pre class="text-xs whitespace-pre-wrap">{{ modalData.entityBefore }}</pre>
        }
        @if (modalData.entityAfter) {
          <p>Entidade depois:</p>
          <pre class="text-xs whitespace-pre-wrap">{{ modalData.entityAfter }}</pre>
        }
      }
    } @else {
      <p>Ué?</p>
    }
  </div>
</app-modal>
